export default __webpack_public_path__ + "static/media/Harjot_Singh_Resume.70698c1d.pdf";